var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_vm._v("404")]),_c('v-card-subtitle',[_vm._v("Page not allowed or not found")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }